'use client'

import { useEffect } from 'react'

/**
 * Insider ~200–300ms main-thread cost. On mobile PSI/LCP, defer longer than desktop
 * so the hero can paint before third-party script parse + execution.
 */
export function DeferredInsiderScript() {
  useEffect(() => {
    const isNarrow =
      typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 768px)').matches
    const delayMs = isNarrow ? 10_000 : 3_000

    const timer = window.setTimeout(() => {
      if (document.getElementById('insider-script')) return
      const el = document.createElement('script')
      el.src = 'https://coolmatevn.api.useinsider.com/ins.js?id=10003475'
      el.async = true
      el.id = 'insider-script'
      document.head.appendChild(el)
    }, delayMs)

    return () => window.clearTimeout(timer)
  }, [])

  return null
}
